export const getSubdomainFromUrl = (hostname: string) => {
  const parts = hostname.split(".");
  return (parts.length > 2 ? parts[0] : "app")
    .replace("https://", "")
    .replace("http://", "");
};
